import {useState} from 'react';

import {useLinkNavigation} from '../../../components/common/navigation/useLinkNavigation';
import {buildSettingsPath} from '../../../models/url/settingsUrlHelpers';
import {
  SettingsApplicationComponentsEnum,
  SettingsApplicationsUrl,
} from '../../../models/url/settingsUrlModel';

export function useSearchQuery(url: SettingsApplicationsUrl) {
  const {navigateToLink} = useLinkNavigation();

  const [searchQuery, setSearchQuery] = useState(url.searchQuery ?? '');

  const onSearchQueryChange = (newQuery?: string) => {
    // If `newQuery` is not defined, it means we removed everything from the input.
    if (!newQuery) {
      resetSearchQuery();
      return;
    }

    setSearchQuery(newQuery);

    // Update URL.
    navigateToLink(buildPathWithQuery(url, newQuery));
  };

  const resetSearchQuery = () => {
    setSearchQuery('');

    // Update URL.
    navigateToLink(buildPathWithQuery(url, undefined));
  };

  return {
    searchQuery,
    resetSearchQuery,
    onSearchQueryChange,
  };
}

function buildPathWithQuery(url: SettingsApplicationsUrl, searchQuery: string | undefined): string {
  switch (url.componentPage) {
    case SettingsApplicationComponentsEnum.AUTOLINKERS:
      return buildSettingsPath({
        ...url,
        autolinkerId: undefined,
        searchQuery,
      });

    case SettingsApplicationComponentsEnum.OAUTH_CLIENT:
      return buildSettingsPath(url);

    case SettingsApplicationComponentsEnum.PREVIEWERS:
      return buildSettingsPath({
        ...url,
        previewerId: undefined,
        searchQuery,
      });

    case SettingsApplicationComponentsEnum.SERVERS:
      return buildSettingsPath({
        ...url,
        serverId: undefined,
        searchQuery,
      });

    default:
      return buildSettingsPath({
        ...url,
        applicationId: undefined,
        searchQuery,
      });
  }
}
